import { mapState } from 'vuex';

import { modalFormMixin } from './modalForm';
import { notificationsMixin } from './notifications';

/**
 * Mixin listy encji
 * Zawiera pola:
 *  - `list` - lista encji
 *  - `count` - liczba encji
 *  - `idToDelete` - identyfikator obiektu do usunięcia
 * Zawiera metody:
 *  - `showDeleteDialog(id)` - wyświetla potwierdzenie usunięcia
 *  - `hideDeleteDialog()` - ukrywa potwierdzenie usunięcia
 *  - `remove(id)` - usuwa encję
 *  - `reloadList(pagination)` - przeładowuje listę
 * Pobiera listę encji przed załadowaniem komponentu
 *
 * @export
 * @param {*} moduleName - nazwa modułu store
 * @param {Object} messages - obiekt z powiadomieniami do wyświetlenia po wykonaniu akcji i w przypadku niepowodzenia
 * @param {string} messages.added - wiadomość po dodaniu encji
 * @param {string} messages.addError - wiadomość w przypadku niepowodzenia przy dodawaniu encji
 * @param {string} messages.updated - wiadomość po aktualizacji encji
 * @param {string} messages.updateError - wiadomość w przypadku niepowodzenia przy aktualizacji encji
 * @param {string} messages.deleted - wiadomość po usunięciu encji
 * @param {string} messages.deleteError - wiadomość w przypadku niepowodzenia przy usuwaniu encji
 * @param {string} messages.listError - wiadomość w przypadku niepowodzenia przy pobieraniu listy
 * @param {string} messages.getError - wiadomość w przypadku niepowodzenia przy pobieraniu encji
 * @param {string} messages.deleteConfirm - wiadomość w przypadku niepowodzenia przy pobieraniu encji
 * @param {*} filters - obiekt z filtrami listy
 * @returns {Object} mixin
 */
export function listMixin(moduleName, messages, filters) {
  return {
    mixins: [notificationsMixin, modalFormMixin(moduleName, messages)],
    /**
     * Dane modułu
     *
     * @returns
     */
    data() {
      return {
        moduleName
      };
    },
    methods: {
      // @vuese
      // Otwiera okienko z potwierdzeniem usunięcia
      showDeleteDialog(id) {
        this.$store.dispatch('setConfirm', {
          title: 'Usuwanie',
          description: messages.deleteConfirm,
          onSuccess: () => {
            this.remove(id);
          }
        });
      },

      // @vuese
      // Usuwa encję
      remove(id) {
        this.$store
          .dispatch(`${moduleName}/remove`, id)
          .then(() => this.notifySuccess(messages.deleted))
          .catch(err => this.notifyError(messages.deleteError));
      },

      // @vuese
      // Aktualizacja listy
      updateList(to, from, next) {
        this.$store
          .dispatch(`${moduleName}/list`, this.getFilters(to))
          .then(() => next && next())
          .catch(err => this.notifyError(messages.listError));
      },

      // @vuese
      // Filtry listy
      getFilters(route) {
        return { ...route.query, ...filters };
      }
    },
    computed: mapState({
      list: state => state[moduleName].list,
      count: state => state[moduleName].count
    }),
    beforeRouteUpdate(to, from, next) {
      this.updateList(to, from, next);
    }
  };
}
